import React from 'react';
import { Provider } from 'react-redux';
import UserflowTheme from '@lt/components/themes/userflow';

import UIGlobalStyles from '@lt/components/styles/styles';
import MobileAppPopupContainer from 'src/components/Banners/MobileAppPopup';
import ErrorBoundary from 'src/error/components/ErrorBoundary';
import LazyDesktopAppBanner from 'src/components/Banners/DesktopAppBanner/LazyDesktopAppBanner';

import { isSSR } from 'src/helpers/ssr';
import { getViewInitialState } from 'src/store/view/reducer';
import Layout from 'src/components/Layout';
import { getStore } from './store';

import SearchPage from './components/SearchPage';
import { MODULE_NAME } from '../../constants';

interface ISearchPageApp {
  searchType?: string;
  isMobile: boolean;
}

const { isWhitelabel } = getViewInitialState();
const SearchPageApp = (props: ISearchPageApp) => {
  const { searchType, isMobile } = props;

  if (!searchType) {
    // TODO: Я бы тут реализовал модальное окно, которое будет выводить ошибку
    // eslint-disable-next-line no-console
    console.error('Поле searchType не объявлено');
  }

  return (
    <ErrorBoundary>
      <Provider store={getStore(props)}>
        <UIGlobalStyles />
        <UserflowTheme>
          <Layout appName={MODULE_NAME.SEARCH}>
            <>
              <SearchPage />
              <MobileAppPopupContainer />
              {!isMobile && !isSSR && !isWhitelabel ? (
                <LazyDesktopAppBanner />
              ) : null}
            </>
          </Layout>
        </UserflowTheme>
      </Provider>
    </ErrorBoundary>
  );
};

export default SearchPageApp;
